// src/services/api.ts
import { getApiBaseUrl } from '../utils';

// Получаем базовый URL API из переменных окружения
const API_BASE_URL = getApiBaseUrl();

export const api = async (
  url: string,
  options: RequestInit = {},
  newToken?: string,
  isRetrying = false
): Promise<Response> => {
  const token = localStorage.getItem('access_token');

  const headers: HeadersInit = {
    ...options.headers,
    'Content-Type': 'application/json',
    Authorization: newToken ? `Bearer ${newToken}` : token ? `Bearer ${token}` : '',
  };

  const response = await fetch(`${API_BASE_URL}/${url}`, {
    ...options,
    headers,
    credentials: 'include',
  });

  if (response.status === 401 && !isRetrying) {
    // Пытаемся обновить токен только один раз
    const refreshResponse = await fetch(`${API_BASE_URL}/auth/refresh`, {
      method: 'POST',
      credentials: 'include',
    });

    if (refreshResponse.ok) {
      const refreshData = await refreshResponse.json();
      localStorage.setItem('access_token', refreshData.access_token);

      const updatedOptions = {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${refreshData.access_token}`,
        },
      };

      return api(url, updatedOptions, undefined, true);
    } else {
      throw new Error('Сессия истекла. Пожалуйста, войдите снова.');
    }
  }

  return response;
};
